export default {
      id: "icon--quote-usage",
      viewBox: "0 0 99 81",
      url: __webpack_public_path__ + "./../Views/Shared/_SvgSprite.cshtml#icon--quote",
      toString: function () {
        return this.url;
      }
    }